<template >
  <div class="row" style="margin-top: 0px !important">
    <!-- <div class="col-12" style="
    padding-left: 5px;
    padding-right: 5px;
">
            <div class="card card-style" style="background-color: white; margin-left: 0px; margin-right: 0px;">
                <div class="card-body">
                        <h3 class="card-title">Quando acionar o SAMU?</h3>
                        <p class="card-text">
                          <ul>
                            <li>Na ocorrência de problemas cardio-respiratórios;</li>
                            <li>Intoxicação exógena e envenenamento;</li>
                            <li>Queimaduras graves;</li>
                            <li>Trabalhos de parto em que haja risco de morte da mãe ou do feto;</li>
                            <li>Em tentativas de suicídio;</li>
                            <li>Crises hipertensivas e dores no peito de aparecimento súbito;</li>
                            <li>Quando houver acidentes/traumas com vítimas;</li>
                            <li>Supeira de infarto ou AVC (alteração súbina na fala, perda de força em um lado do corpo e desvio da comissura labial são os sintomas mais comuns); </li>
                            <li>Agressão por arma de fogo ou arma branca;</li>
                            <li>Crises Convulsivas;</li>
                            <li>Outras situações consideradas de urgência ou emergência, com risco de morte, sequela ou sofrimento intenso.</li>
                          </ul>
                        
                        </p>
                        <h3 class="card-title">Quando não acionar o SAMU?</h3>
                        <p class="card-text">
                          <ul>
                            <li>Febre prolongada;</li>
                            <li>Dores crônicas;</li>
                            <li>Vômito e diarreia;</li>
                            <li>Levar pacientes para consulta médica ou para realizar exames;</li>
                            <li>Transporte de óbito;</li>
                            <li>Dor de dente;</li>
                            <li>Transferência sem regulação médica prévia;</li>
                            <li>Trocas de sonda;</li>
                            <li>Corte com pouco sangramento;</li>
                            <li>Entorses;</li>
                            <li>Cólicas renais;</li>
                            <li>Transportes inter-hospitalares de pacientes de convênio;</li>
                            <li>Todas as demais situações onde não se caracterize urgência ou emergência médica.</li>
                          </ul>
                          <a href="https://www.gov.br/saude/pt-br/assuntos/saude-de-a-a-z/s/samu-192" target="_blank">Fonte: https://www.gov.br/saude/pt-br/assuntos/saude-de-a-a-z/s/samu-192</a>
                        </p>
                    </div>
            </div>
        </div> -->
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    /* changeStatusReceive(object) {
      const self = this;
      const api = self.$store.state.api + "teste";

      self.isLoading = true;

      self.$http
        .post(api, object)
        .then((response) => {})
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    }, */
  },
  components: { Loading },
  props: {},
  mounted: function () {
    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    document.body.setAttribute("style", null);
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/QuandoChamarSamu.vue